import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import UserContext from "../../context/UserContext";

const Logout: React.FC = () => {
    //@ts-ignore
    const [user, setUser] = useContext(UserContext);
    const [loggedIn, setLoggedIn] = useState(true);

    useEffect(() => {
        handleLogout();
    }, []);

    function handleLogout() {
        Cookies.remove("token");
        Cookies.remove("id");
        Cookies.remove("info");
        Cookies.remove("current_filter");
        Cookies.remove("admin");
        setUser({});
        setLoggedIn(false);
    }

    return loggedIn ? <Redirect to="http://13.235.209.150/auth?token=&redirect_url=http://13.235.209.150/login&gr=logout" /> : <div></div>;
};

export default Logout;
